import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';
/**
 * Custom exception.
 */
export default class ShoppingCartException extends AbstractException {
    /**
     * Class constructor.
     *
     * @param failedShoppingItems Failed shopping items from the server. Probably from the NifApi when add to cart request fails.
     * @param errorList Expected errors from the Cart API.
     */
    constructor(failedShoppingItems, errorList) {
        super(`Error when trying to add items to cart. ${failedShoppingItems ? 'Article errors: ' + JSON.stringify(failedShoppingItems) : ''}`);
        this.exceptionType = ExceptionTypeEnum.shoppingCart;
        this.name = 'ShoppingCartException';
        this.failedShoppingItems = Array();
        this.errorList = Array();
        this.failedShoppingItems = failedShoppingItems;
        this.errorList = errorList;
    }
}
//# sourceMappingURL=ShoppingCartException.js.map